const formatter = new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' })

export const formatCurrency = (amount) => {
  return formatter.format(amount)
}
